<template>
<b-row>
  <b-col sm="12" md="4">
    <b-form-group>
      <label>{{$t('views.exsbdocument.form.documentType')}}:</label>
      <multi-select :placeholder="$t('views.exsbdocument.form.documentType')" @select="onSelectTag" :options="documentTypeOptions" :selected-options="documentTypes"></multi-select>
    </b-form-group>
  </b-col>
  <b-col sm="12" md="4">
    <b-form-group>
      <label>{{$t('views.exsbdocument.form.exhibitor')}}:</label>
      <model-select :placeholder="$t('views.exsbdocument.form.exhibitor')" :options="userDataOptions" v-model="filters.exhibitorNip"></model-select>
    </b-form-group>
  </b-col>
  <b-col sm="12" md="4">
    <b-form-group>
      <label>{{$t('views.exsbdocument.form.receiver')}}:</label>
      <model-select :placeholder="$t('views.exsbdocument.form.receiver')" :options="userDataOptions" v-model="filters.receiverNip"></model-select>
    </b-form-group>
  </b-col>
  <b-col md="4" sm="12">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbdocument.list.number') }}:</label>
      <input :placeholder="$t('views.exsbdocument.list.number')" v-model.lazy="filters.number" v-debounce="delay" class="form-control" type="text">
    </div>
  </b-col>
  <b-col md="4" sm="12">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.exsbdocument.list.invoiceNumber') }}:</label>
      <input :placeholder="$t('views.exsbdocument.list.invoiceNumber')" v-model.lazy="filters['idInvoice.number']" v-debounce="delay" class="form-control" type="text">
    </div>
  </b-col>
  <b-col sm="12" md="4">
    <b-form-group>
      <label>{{$t('views.excmtask.list.table.task')}}:</label>
      <model-select :placeholder="$t('views.excmtask.list.table.task')" :options="taskTypeOptions" v-model="filters['task.idTaskType']"></model-select>
    </b-form-group>
  </b-col>
  <b-col md="6" sm="12">
    <b-form-group>
      <label>{{$t('views.exsbdocument.list.dateOfIssueFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.exsbdocument.list.dateOfIssueFrom')"
                            v-model.lazy="filters['dateOfIssue[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="6" sm="12">
    <b-form-group>
      <label>{{$t('views.exsbdocument.list.dateOfIssueTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.exsbdocument.list.dateOfIssueTo')"
                            v-model.lazy="filters['dateOfIssue[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
</b-row>
</template>

<script>
import debounce from 'v-debounce'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { MultiSelect, ModelSelect } from 'vue-search-select'
import addParamsToQuery from '@/utils/addParamsToQuery'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'DocumentFiltering',
  components: { MultiSelect, VueCtkDateTimePicker, ModelSelect },
  data () {
    return {
      delay: 500,
      lastSelectItem: {},
      documentTypes: [],
      documentTypeOptions: [],
      taskTypeOptions: [],
      userDataOptions: [],
      filters: {
        documentType: [],
        'dateOfIssue[after]': '',
        'dateOfIssue[before]': '',
        number: '',
        'idInvoice.number': '',
        'task.idTaskType': '',
        exhibitorNip: '',
        receiverNip: ''
      }
    }
  },
  directives: {
    debounce
  },
  created () {
    this.fetchDocumentTypeOptions()
    this.fetchTaskTypeOptions()
    this.fetchUserDataOptions()
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_s_b_documents'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    async fetchDocumentTypeOptions () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_s_b_document_types', params).getResults()
      this.documentTypeOptions = response.items.map(type => {
        return {
          value: type['@id'],
          text: type.name
        }
      })
    },
    async fetchTaskTypeOptions () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_c_m_task_types', params).getResults()
      this.taskTypeOptions = response.items.map(type => {
        return {
          value: getId(type['@id']),
          text: type.title
        }
      })
    },
    async fetchUserDataOptions () {
      let params = { pagination: false, isCompany: 1 }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.userDataOptions = response.items.map(userData => {
        return {
          value: userData.nip,
          text: userData.firmname1
        }
      })
    },
    onSelectTag (items, lastSelectItem) {
      this.documentTypes = items
      this.filters.documentType = items.map(type => getId(type.value))
      this.lastSelectItem = lastSelectItem
    }
  }
}
</script>

<style scoped>

</style>
